export default __webpack_public_path__ + "static/media/hub-dashboard-1.839459d5.JPG";